export const words = {
  place: "Locatie",
  yes: 'Ja',
  no: "Geen",
  new: "Nieuw",
  agb: 'AGB',
  agb_full: "Algemene voorwaarden",
  datenschutzerklaerung: "Privacybeleid",
  status: 'Status',
  company_name: "Naam van het bedrijf",
  next_button: "Verder",
  device_name: "Naam apparaat",
  to_connect: "Verbind",
  pin: 'PIN',
  time: "Tijd",
  first_name: "Voornaam",
  last_name: "Achternaam",
  code: 'Code',
  help: "Help",
  total_time: "Totale tijd",
  latitude: "Breedtegraad",
  longitude: "Lengtegraad",
  accuracy: "Nauwkeurigheid",
  timestamp: "Tijdstempel",
  device_id: "Apparaat ID",
  active: "actief",
  o_clock: "Klok",
  loading: "Winkel",
  annotation: "Opmerking",
  since: "sinds",
  camera: "Camera",
  map: "Kaart",
  gallery: 'Galerie',
  work: "Werk",
  employees: "Werknemers",
  login: "Registratie",
  login_action: "Inloggen",
  calendar_week_abbreviation: 'KW',
  calendar: 'Kalender',
  to_call: "Bel",
  email: "E-mail",
  attachment: "Bijlage",
  operational_planning: "Operationeel plan",
  to_scan: "Scan",
  download: "Downloaden",
  export: "Exporteer",
  to_document: "Document",
  checklist: "Checklist",
  checklists: "Checklists",
  password: "Wachtwoord",
  confirmation: "Bevestiging",
  confirm: "Bevestig",
  confirmation_email: "Bevestigingsmail",
  unknown: "Onbekend",
  unknown_place: "Onbekende locatie",
  unknown_plan: "Onbenoemd dienstrooster",
  project_no: "Project nr.",
  project_file: "Project dossier",
  contact_person: "Neem contact op met",
  overtime: "Overwerk",
  timesheet: "Dienstregeling",
  minustime: "Minuren",
  back: "Terug",
  undo: "Ongedaan maken",
  clockout: "Stamp eruit",
  clocked_out: "gestempeld",
  clockin: "Stempel in",
  clocked_in: "gestempeld",
  dismiss: "Annuleren",
  discard: "Verwerpen",
  finish: "Klaar",
  or: "of",
  copy: "Kopiëren",
  qr_code: "QR-code",
  documentation: "Tijdregistratie en documentatie",
  attendance: "Tablet terminal",
  tiercontent: "Omvang van het pakket",
  start_now: "Begin nu",
  skip: "overslaan",
  logout_during_core_time: "Uitgestampt tijdens kerntijd",
  absent_during_core_time: "Afwezig tijdens de kerntijd",
  distance: "Afstand",
  km_reading: 'Kilometerstand',
  the_start: 'Start',
  the_end: "Einde",
  license_plate: "Nummerplaat",
  details: "details",
  hide: "verbergen",
  cost: 'Kosten',
  file: "Bestand",
  address_book: "Adresboek",
  template_plural: "Sjablonen",
  signature: "Handtekening",
  main_project: "Hoofdproject",
  main_projects: "Belangrijkste projecten",
  sub_projects: "Deelprojecten",
  scan_to_login_header: "QR-code registratie",
  description: "Beschrijving",
  project_location: "Plaats van het project",
  phone_number: "Telefoonnummer",
  project_info: "Projectinformatie",
  number_short: "Nee.",
  sketch: "Schets",
  video: 'Video',
  delete: "Verwijder",
  send: "Stuur",
  sending: "Verzenden...",
  save: "Opslaan",
  granted: "goedgekeurd",
  pending: "gevraagd",
  denied: "Afgewezen",
  customer: "Klant",
  mobile_number: "Telefoonnummer",
  ok: 'Ok',
  day: "Dag",
  tomorrow: "Ochtend",
  days: "Dagen | Dag | Dagen",
  holidays: "Vakantie",
  vacation_days: "Vakantie",
  vacation_hours: "Vakantie-uren",
  request: "Verzoek",
  accept: "Accepteer",
  withdraw: "Intrekken",
  hour_account: "Uurrekening",
  period: "Periode",
  to: "naar",
  date: "Afspraak",
  number: "Nummer",
  message: "Bericht",
  change: "verandering",
  changed: "Veranderd",
  changed_fields: "Gewijzigde velden",
  type: 'Art',
  hour: "Uur",
  hours: "Uren",
  hours_abbreviation: "Standaard.",
  hours_with_amount: "{amount} Uren",
  end: "eind",
  end_date: "Deadline",
  start_date: "Startdatum",
  absence: "Afwezigheid",
  month: "maand",
  week: "Week",
  transcript: "Afschrift",
  time_left: "overig",
  transcript_tasks: "Taken",
  add_task: "Nieuw",
  /** Differentiation in some languages (e.g. English) */
  from: "van",
  of: "van",
  of_hours: "van {hours} uur",
  of_hours_abbreviation: "{hours} van uur.",
  /**************/

  used: "gebruikte",
  update: "Update",
  today: "vandaag",
  correction: "Correctie",
  work_time: "Werktijd",
  break: "Pauze",
  loading_time: "Laadtijd",
  driving_time: "Reistijd",
  business_trip: "Dienstreizen",
  project: "Project",
  special_one: "Special1",
  special_two: "Special2",
  clock: "Klok",
  search: "Zoek op",
  operation: "Activiteit",
  day_protocol: "Dagelijks protocol",
  continue: "meer",
  total_duration: "Totale tijd",
  duration: "Duur",
  hello: 'Hallo',
  close: "Sluit",
  comment: "Commentaar",
  small: "kleine",
  medium: "medium",
  large: "grote",
  sharpie: "Pin",
  line: "Lijn",
  arrow: "Pijl",
  rectangle: "Rechthoek",
  ellipse: 'Ellipse',
  text: "Tekst",
  language_settings: "Taalinstellingen",
  clock_reminder: "Postzegelherinnering",
  individually: "Individueel",
  from_o_clock: "van",
  to_o_clock: "naar",
  eraser: "Gum",
  edit: "Bewerk",
  legal_notes: "Wettelijk",
  notes: "Opmerkingen",
  note: "Opmerking",
  imprint: "Afdruk",
  open_source_licenses: "Open Source licentievoorwaarden",
  author: "Auteur",
  license_type: "Type vergunning",
  version: "Versie",
  substitute: "Vertegenwoordiging",
  not_rated: "Niet beoordeeld",
  weekly_working_hours: "Wekelijkse werktijden",
  show_less: "Minder tonen",
  office_center: "Kantorencentrum",
  admin_view: "NFC-beheer",
  register: "Registreer",
  shifts: {
    shift_attachments: "Bijlagen (laag)",
    shift_plan_attachments: "Bijlagen (shiftplan)",
    shift_plan: "Dienstrooster",
    shift: "Laag"
  },
  absences: {
    sick: "Ziekte (loondoorbetaling)",
    vacation: "Vakantie",
    workshop: "Seminar/cursus",
    special_vacation: "Bijzonder verlof",
    school: "School",
    working_time_account: "Werktijdrekening",
    holiday: "Vakantie",
    other: "Andere",
    driving_time: "Reistijd",
    parental_leave: "Ouderschapsverlof",
    excused_absent: "Afwezig verontschuldigd (betaald)",
    not_excused_absent: "Afwezigheid zonder excuus",
    sick_industrial_accident: "Ziekte Bedrijfsongeval (LFZ)",
    short_time_work: "Arbeidstijdverkorting (Kug)",
    maternity_pay: "Zwangerschapsbescherming loon/werkverbod",
    sick_child: "Zorgen voor een ziek kind met (dag)loon",
    sick_child_no_payment: "Verzorging van een ziek kind zonder ziekte(dag)loon",
    vacation_no_payment: "Onbetaald verlof",
    sick_before_short_time_work: "Ziekte-uitkering/ziekte voor Kug",
    weather_related_failure: "Uitval door weersomstandigheden",
    sick_short_time_work: "Ziekte tijdens Kug",
    sick_no_payment: "Ziekte (zonder loondoorbetaling)",
    company_vacation: "Vakantie",
    meals_14_euro: "Kleine cateringvergoeding",
    meals_28_euro: "Grote cateringtoelage"
  },
  image_editor: {
    font_size: "Lettergrootte",
    stroke_width: "Lijnbreedte",
    stroke_color: "Lijnkleur",
    text_color: "Kleur van het lettertype",
    rotate_left: "Draai naar links",
    rotate_right: "Draai naar rechts",
    flip_horizontal: "Spiegel horizontaal",
    flip_vertical: "Verticaal spiegelen"
  },
  travel_log: {
    method_of_transportation: "Transportmiddelen",
    company_car: "Auto van de zaak",
    private_car: "Eigen auto",
    rental_car: "Huurauto",
    taxi: 'Taxi',
    public_transportation: "Openbaar vervoer",
    airplane: "Vliegtuig",
    train: "Spoor (openbaar vervoer over lange afstand)",
    other: 'Andere',
    km_reading_start: "Kilometerstand start",
    km_reading_end: "Kilometerstand einde",
    net_expenses: "Reiskosten (netto)",
    tax: "Belasting toegevoegde waarde"
  },
  read_in: "Lees verder",
  currency: "Valuta",
  reason: "Reden",
  label: "Etiket",
  monday: "Maandag",
  tuesday: "Dinsdag",
  wednesday: "Woensdag",
  thursday: "Donderdag",
  friday: "Vrijdag",
  saturday: "Zaterdag",
  sunday: "Zondag",
  break_alarm: "Wekker breken",
  clockin_reminder: "Inklokherinnering",
  clockout_reminder: "Onthoud je afmelden"
};